var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85377 0C6.43938 0 6.10342 0.321879 6.10342 0.718907V23.8198C6.10342 24.2168 6.43938 24.5387 6.85377 24.5387H15.8579L16.3582 22.8694V1.59195L15.8579 0L6.85377 0Z",
    fill: "#CFE1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5363 3.26379L19.5574 0H15.8557V24.5387H24.8598C25.2742 24.5387 25.6102 24.2168 25.6102 23.8198V5.03235L21.5363 3.26379Z",
    fill: "#CFE1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0599 5.03235H25.6125L19.5597 0V4.55308C19.5597 4.81778 19.7837 5.03235 20.0599 5.03235Z",
    fill: "#BFD7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8544 19.6991V23.114H12.4828C12.1709 23.114 12.0147 23.4753 12.2352 23.6867L15.5044 26.8189C15.6021 26.9125 15.7301 26.9593 15.8581 26.9593L16.3584 26.3338V20.2062L15.8581 19.6991L13.8544 19.6991Z",
    fill: "#1648CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2313 23.114H17.8597V19.6992H15.8559V26.9593C15.9839 26.9593 16.1119 26.9125 16.2096 26.8189L19.4788 23.6867C19.6994 23.4754 19.5432 23.114 19.2313 23.114Z",
    fill: "#1648CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.750346 5.99091C0.335955 5.99091 0 6.31278 0 6.70981V15.3846C0 15.7817 0.335955 16.1035 0.750346 16.1035H10.1547L10.6549 15.3726V6.64204L10.1547 5.99091H0.750346Z",
    fill: "#FF597D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5584 5.99091H10.154V16.1035H19.5584C19.9728 16.1035 20.3087 15.7817 20.3087 15.3846V6.70981C20.3087 6.31278 19.9728 5.99091 19.5584 5.99091Z",
    fill: "#FF306D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07765 8.16007L3.61447 8.18341C3.20498 8.18997 2.87663 8.50984 2.87663 8.90222V13.2157C2.87663 13.6127 3.21259 13.9346 3.62698 13.9346C4.04137 13.9346 4.37733 13.6127 4.37733 13.2157V12.4968H5.11537C6.36339 12.4968 7.37871 11.524 7.37871 10.3282C7.37871 9.12465 6.35384 8.14085 5.07765 8.16007ZM5.11537 11.059H4.37733V9.60929L5.10266 9.59769C5.52796 9.59055 5.87802 9.9188 5.87802 10.3283C5.87802 10.7312 5.53591 11.059 5.11537 11.059Z",
    fill: "#F0F7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62931 12.4968V9.62116C9.81404 9.62116 9.99098 9.65352 10.1546 9.71227L10.6548 8.97022L10.1546 8.22835C9.98387 8.19936 9.80854 8.18335 9.62931 8.18335H8.87896C8.46457 8.18335 8.12862 8.50523 8.12862 8.90226V13.2157C8.12862 13.6127 8.46457 13.9346 8.87896 13.9346H9.62931C9.80854 13.9346 9.98387 13.9186 10.1546 13.8896L10.6548 13.1092L10.1546 12.4057C9.99098 12.4644 9.81404 12.4968 9.62931 12.4968Z",
    fill: "#F0F7FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6301 11.059C12.6301 9.64512 11.5592 8.46717 10.154 8.22839V9.71231C10.7232 9.91677 11.1294 10.4432 11.1294 11.059C11.1294 11.6748 10.7232 12.2013 10.154 12.4057V13.8896C11.5592 13.6509 12.6301 12.4729 12.6301 11.059Z",
    fill: "#DDEDFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6824 8.18335H14.1312C13.7168 8.18335 13.3808 8.50523 13.3808 8.90226V13.2157C13.3808 13.6127 13.7168 13.9346 14.1312 13.9346C14.5456 13.9346 14.8815 13.6127 14.8815 13.2157V12.4968H15.882C16.2964 12.4968 16.6323 12.1749 16.6323 11.7779C16.6323 11.3809 16.2964 11.059 15.882 11.059H14.8815V9.62116H16.6824C17.0967 9.62116 17.4327 9.29929 17.4327 8.90226C17.4327 8.50523 17.0967 8.18335 16.6824 8.18335Z",
    fill: "#DDEDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.ff04a4ee30c8e25f4d395387ad0d816e.svg";
export { ForwardRef as ReactComponent };